import { Controller } from 'react-hook-form'
import * as z from 'zod'
import { YesNoRadioGroup } from '~/shadcn/ui/yes-no-radio-group'
import { FormStep } from '~/@pages_onboarding/investor-analysis/_analysis-form/FormStep'
import { StepTitle } from '~/@pages_onboarding/investor-analysis/_analysis-form/StepTitle'
import { useFormStepSophisticated } from '../form-step-sophisticated/useFormStepSophisticated'
import { useQuestionsV1 } from '../../questions'

const step4Schema = z.object({
  averaged10LargeTransactionsQuarterlyLastYear: z.boolean(),
})

export type Step4Data = z.infer<typeof step4Schema>

export function Step4() {
  const { formData, onCompleted } = useFormStepSophisticated()
  const question =
    useQuestionsV1().sophisticated.averaged10LargeTransactionsQuarterlyLastYear

  return (
    <FormStep
      defaultValues={formData}
      schema={step4Schema}
      onStepCompleted={(updatedData) =>
        onCompleted({ ...formData, ...updatedData })
      }
      render={({ control }) => (
        <>
          <StepTitle>{question.question.label}</StepTitle>
          <Controller
            control={control}
            name="averaged10LargeTransactionsQuarterlyLastYear"
            render={({ field }) => (
              <YesNoRadioGroup
                value={field.value}
                labelYes={question.answers.true.label}
                labelNo={question.answers.false.label}
                onValueChange={field.onChange}
              />
            )}
          />
        </>
      )}
    />
  )
}
